import { render, staticRenderFns } from "./statisticsData.vue?vue&type=template&id=40e0c69b&"
import script from "./statisticsData.vue?vue&type=script&lang=js&"
export * from "./statisticsData.vue?vue&type=script&lang=js&"
import style0 from "./statisticsData.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports